<a
    [href]="facebookUrl"
    class="pill pill--facebook">
    <i class="uil uil-facebook"></i>
    Facebook
</a>
